module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/connect.json
// module id = 679
// module chunks = 177134156304145